import React from "react";
import { DemoCarousel } from "./Carousel";
import "../styles/customer-reviews.css";

const CustomerReview = () => (
  <section
    id="reviews"
    className="customer-reviews"
    aria-labelledby="customer-reviews-heading"
  >
    <div className="customer-reviews__container">
      <header className="customer-reviews__intro" data-aos="fade-up">
        <p className="customer-reviews__eyebrow">Kind words from our clients</p>
        <h2 id="customer-reviews-heading">Stories that make us smile</h2>
        <p>
          A few words from people who trusted Arpita's Makeover for their
          special moments.
        </p>
        <span className="customer-reviews__ornament" aria-hidden="true">
          <span />
          <i className="fas fa-gem" />
          <span />
        </span>
      </header>

      <div className="customer-reviews__stage" data-aos="fade-up" data-aos-delay="100">
        <DemoCarousel />
      </div>
    </div>
  </section>
);

export default CustomerReview;
